import { render, staticRenderFns } from "./SubHeader.vue?vue&type=template&id=6a6cdbc0&scoped=true"
import script from "./SubHeader.vue?vue&type=script&lang=js"
export * from "./SubHeader.vue?vue&type=script&lang=js"
import style0 from "./SubHeader.vue?vue&type=style&index=0&id=6a6cdbc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6cdbc0",
  null
  
)

export default component.exports